import React, { useContext } from 'react';

type CookieConsentContextType = {
  measurementAllowed: boolean;
};

const CookieConsentContext = React.createContext<CookieConsentContextType>({
  measurementAllowed: false,
});

const useCookieConsent = () => useContext(CookieConsentContext);

export { useCookieConsent };
export default CookieConsentContext;
